import { render, staticRenderFns } from "./widgets.vue?vue&type=template&id=30274406&"
import script from "./widgets.vue?vue&type=script&lang=js&"
export * from "./widgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports